export interface UpdatePatrolDaysRequest {
  branchCode: string
  placeCode: string
  year: number | string
  month: number | string
  days: string[]
}

export function UpdatePatrolDaysRequestToJSON(
  value: UpdatePatrolDaysRequest
): any {
  return {
    branch_code: value.branchCode !== '' ? value.branchCode : undefined,
    place_code: value.placeCode !== '' ? value.placeCode : undefined,
    year: value.year !== '' ? value.year : undefined,
    month: value.month !== '' ? value.month : undefined,
    days: Array.isArray(value.days) ? value.days : undefined
  }
}
